import { useState } from "react";
import { toast } from "sonner";
import { LogIn, ShieldCheck } from "lucide-react";
import { adminLogin, setToken } from "../../lib/api";

export const AdminLogin = ({ onAuthenticated }) => {
    const [creds, setCreds] = useState({ username: "admin", password: "" });
    const [loading, setLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const data = await adminLogin(creds.username, creds.password);
            setToken(data.token);
            toast.success("¡Bienvenido!");
            onAuthenticated();
        } catch (err) {
            toast.error(err.response?.data?.detail || "Credenciales inválidas");
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="min-h-[80vh] grain-bg flex items-center py-20" data-testid="admin-login-section">
            <div className="container-fe max-w-md w-full">
                <div className="rounded-3xl bg-white border border-black/5 p-10 shadow-2xl">
                    <div className="h-14 w-14 rounded-2xl bg-brand-green text-white flex items-center justify-center">
                        <ShieldCheck size={26} />
                    </div>
                    <h1 className="mt-6 font-display font-bold text-3xl text-brand-navy">Acceso administrativo</h1>
                    <p className="mt-2 text-sm text-muted-foreground">Solo personal autorizado de la fundación.</p>
                    <form onSubmit={handleLogin} className="mt-8 space-y-4" data-testid="admin-login-form">
                        <div>
                            <label className="block text-sm font-semibold text-brand-navy mb-2">Usuario</label>
                            <input
                                data-testid="admin-input-username"
                                value={creds.username}
                                onChange={(e) => setCreds({ ...creds, username: e.target.value })}
                                className="w-full h-12 rounded-xl border border-border bg-white px-4 focus:outline-none focus:ring-2 focus:ring-brand-green"
                                required
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-semibold text-brand-navy mb-2">Contraseña</label>
                            <input
                                type="password"
                                data-testid="admin-input-password"
                                value={creds.password}
                                onChange={(e) => setCreds({ ...creds, password: e.target.value })}
                                className="w-full h-12 rounded-xl border border-border bg-white px-4 focus:outline-none focus:ring-2 focus:ring-brand-green"
                                required
                            />
                        </div>
                        <button
                            type="submit"
                            disabled={loading}
                            className="btn-primary-pill w-full disabled:opacity-50"
                            data-testid="admin-login-submit"
                        >
                            <LogIn size={16} /> {loading ? "Accediendo..." : "Iniciar sesión"}
                        </button>
                    </form>
                </div>
            </div>
        </section>
    );
};
